import { render, staticRenderFns } from "./tag-search-select.vue?vue&type=template&id=4402cc8a&"
import script from "./tag-search-select.vue?vue&type=script&lang=ts&"
export * from "./tag-search-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports